import type { Breakpoint } from '@builder4/shared/types/layout';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { ROOT_NODE, useEditor } from '@craftjs/core';
import { setBreakpoint, setFullscreenPreview } from '@/store/system/systemSlice';
import type { PageProps } from '@builder4/shared/components/Page';
import { selectIsFullscreenPreview } from '@/store/system/selectors';

const useBreakpoint = () => {
  const dispatch = useAppDispatch();
  const isFullscreenPreview = useAppSelector(selectIsFullscreenPreview);

  const { actions } = useEditor();

  const switchPreviewBreakpoint = (newBreakpoint: Breakpoint) => {
    actions.history.ignore().setProp(ROOT_NODE, (props: PageProps) => {
      props.breakpoint = newBreakpoint;
    });
    dispatch(setBreakpoint(newBreakpoint));
  };

  const switchBreakpoint = (newBreakpoint: Breakpoint, skipHistory = false) => {
    if (skipHistory) {
      actions.history.ignore().setProp(ROOT_NODE, (props: PageProps) => {
        props.breakpoint = newBreakpoint;
      });
    } else {
      actions.setProp(ROOT_NODE, (props: PageProps) => {
        props.breakpoint = newBreakpoint;
      });
    }
    dispatch(setBreakpoint(newBreakpoint));
  };

  const toggleFullscreenPreview = () => {
    dispatch(setFullscreenPreview(!isFullscreenPreview));
  };

  return { switchBreakpoint, switchPreviewBreakpoint, toggleFullscreenPreview };
};

export default useBreakpoint;
